<div class="admin-container">
  <div>
    <span class="pageHeader">
									Maintain Lookup Tables
								</span>
  </div>
  <div class="admin-Content">
    <div>
      <a routerLink="/postPurchaseAdj">
        <span class="bodyTextDefaultSizeWithUnderline"> Post Purchase Adjustments  </span>
      </a>
      <span> - Post Purchase Adjustments </span>
    </div>

    <div>
      <a routerLink="/holiday">
        <span class="bodyTextDefaultSizeWithUnderline"> Holiday  </span>
      </a>
      <span> - View and Update Holiday Table </span>
    </div>
    <div>
      <a routerLink="/adminReports">
        <span class="bodyTextDefaultSizeWithUnderline"> Reports </span>
      </a>
      <span>&nbsp;- Run Internal Reports </span>
    </div>

    <div>
      <a routerLink="/updateSystemAttributes">
        <span class="bodyTextDefaultSizeWithUnderline"> Update System Attributes </span>
      </a>
      <span> - &nbsp;Update System Attributes </span>
    </div>

  </div>
</div>
